import { Controller } from "@hotwired/stimulus"
import Toastify from 'toastify-js'

export default class extends Controller {
  static targets = ["firstStep", "secondStep", "thirdStep", "fourthStep"]
  connect() {
    // this.initialize(this.element);
    this.steps = ["firstStep", "secondStep", "thirdStep", "fourthStep"];
  }

  goSecondStep() {
    const teachingLevel = document.querySelector("input[name*=teaching_level_id]:checked");
    const course = document.querySelector("input[name*=course_id]:checked");
    if (teachingLevel?.value === "" || course?.value === "" || course === null || teachingLevel === null) {
      if (course === null) this.toaster("Por favor, selecione um curso");
      if (teachingLevel === null) this.toaster("Por favor, selecione um nível de ensino");
      return;
    }
    this.firstStepTarget.classList.add("hidden");
    this.secondStepTarget.classList.remove("hidden");
  }

  goThirdStep() {
    const modality = document.querySelector("input[name*=modality_id]:checked");
    if (modality?.value === "" || modality === null) {
      if (modality === null) this.toaster("Por favor, selecione uma modalidade");
      return;
    }

    this.secondStepTarget.classList.add("hidden");
    this.thirdStepTarget.classList.remove("hidden");
  }

  goFourthStep() {
    const state = document.querySelector("select[name*=state_id]");
    const city = document.querySelector("select[name*=city_id]");
    const pole = document.querySelector("input[name*=pole_id]:checked");
    const modality = document.querySelector("input[name*=modality_id]:checked");

    if (state?.value === "" || isNaN(parseInt(state?.value)) || city?.value === "" || isNaN(parseInt(city?.value)) || pole?.value === "" || pole === null) {
      if (modality.dataset.name !== "Presencial" && modality.dataset.name !== "Semipresencial") {
        if (state?.value === "" || isNaN(parseInt(state?.value))) this.toaster("Por favor, selecione um estado");
        if (city?.value === "" || isNaN(parseInt(city?.value)) ) this.toaster("Por favor, selecione uma cidade");
        if (pole?.value === "" || pole === null) this.toaster("Por favor, selecione um polo");
        return;
      }
      if (pole === null) {
        this.toaster("Por favor, selecione um polo");
        return;
      }
    }
    this.dispatchEvent('pole');
    this.thirdStepTarget.classList.add("hidden");
    this.fourthStepTarget.classList.remove("hidden");
  }

  prevStep(e) {
    const stepElement = e.currentTarget.parentElement.parentElement.parentElement.parentElement;
    const currentStep = stepElement.dataset.stepTarget;
    const currentStepPos = this.steps.indexOf(currentStep);
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete("curso");
    urlParams.delete("formacao");
    
    if (!location.href.match(/editar|nova/))  history.replaceState({}, '', `${window.location.origin}/nova`);
    
    stepElement.classList.add("hidden");
    const toShow = document.querySelector(`div[data-step-target*=${this.steps[currentStepPos - 1]}]`);
    toShow.classList.remove("hidden");
  }

  toaster(message) {
    Toastify({
      gravity: "bottom",
      position: 'right',
      style: { background: "#102f6d" },
      close: true,

      text: message,
      
      duration: 3000
      
    }).showToast();
  }

  dispatchEvent(step, action = 'active') {
    const event = new CustomEvent("stepbar:update", {
      detail: { step: step, action: action }, 
      bubbles: true 
    });
    document.querySelector('body').dispatchEvent(event);
  }

}